import React from 'react';
import { questions } from '../Question';
import { Grid } from '@material-ui/core';
import { RadioOptionRhf } from '../components/RadioRhf/RadioOptionRhf';
import RetainerTooltip from '../components/RetainerTooltip/RetainerTooltip';
import useDiffRetainerLangContext from './hooks/useDiffRetainerLangContext';
// import { SelectRhf } from '../components/selectRhf/SelectRhf'
import RadioRhf from '../components/RadioRhf/RadioRhf';
import InfoIcon from '@material-ui/icons/Info';
import CustomTooltip from '../components/CustomTooltip/CustomTooltip';
import useRetainerSubOpts from '../../../pages/hooks/DiffRetainerHooks/useRetainerSubOpts';

const RetainerLabelStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
};

// MUI v4 iconColor props: primary, secondary, action, error, disabled
// https://v4.mui.com/api/icon/
export const infoIconColor = 'secondary';

export const RetainerTypeFormControlLabelRhf = ({
    question = questions,
    fixedWire = undefined,
    selectedRetainer = undefined,
    control,
    errors,
    subType = '',
    isTab,
}) => {
    const option = question[3].option;
    const { getDiffRetainerLang } = useDiffRetainerLangContext();
    const { getWireOptImg } = useRetainerSubOpts();

    return (
        <>
            {option.map((v, _) => {
                const retainerTypeLabel = getDiffRetainerLang(`formOptions.${v.value}`) || v.value;
                let disabled = false;
                if (!v.forPatientHasFixedWire) {
                    disabled = fixedWire !== question[2].option[1].value;
                }
                const showOption = selectedRetainer === v.value;
                if (disabled) return null;
                if (Array.isArray(v.children) && v.children.length > 0) {
                    return (
                        <Grid xs={12} spacing={2} style={{ display: 'flex', width: '100%', flexDirection: 'column' }}>
                            <Grid item style={{ flexGrow: 1 }}>
                                <RadioOptionRhf
                                    value={v.value}
                                    disable={disabled}
                                    label={
                                        <div style={RetainerLabelStyle}>
                                            {retainerTypeLabel}
                                            <RetainerTooltip label={retainerTypeLabel} value={v.value} placement="right">
                                                <InfoIcon color={infoIconColor} />
                                            </RetainerTooltip>
                                        </div>
                                    }
                                />
                            </Grid>
                            <Grid item style={{ flexGrow: 1 }}>
                                <Grid
                                    container
                                    spacing={2}
                                    // direction="row"
                                    direction="column"
                                >
                                    {showOption &&
                                        v.children.map((question) => {
                                            let questionName = question.name;
                                            if (['Upper', 'Lower'].includes(subType)) {
                                                questionName = `${subType}${question.name.charAt(0).toUpperCase()}${question.name.slice(1)}`;
                                            }
                                            if (
                                                question.option &&
                                                Array.isArray(question.option) &&
                                                question.option.length > 0
                                            ) {
                                                return (
                                                    <Grid style={{ marginLeft: 50, marginTop: 12 }}>
                                                        <RadioRhf
                                                            errors={errors}
                                                            row={false}
                                                            control={control}
                                                            name={questionName}
                                                            question={getDiffRetainerLang(
                                                                `formLabel.${question.label}`
                                                            )}
                                                            formControlLabelRhf={
                                                                <>
                                                                    {question.option.map((opt) => {
                                                                        const showToolTip =
                                                                            opt?.title && opt?.translationKey;
                                                                        const textDisplay = opt?.translationKey
                                                                            ? getDiffRetainerLang(
                                                                                  `subOptions.${opt.translationKey}`
                                                                              )
                                                                            : opt.value;
                                                                        return (
                                                                            <>
                                                                                {/* <p>{questionName}</p> */}
                                                                                <RadioOptionRhf
                                                                                    disable={disabled}
                                                                                    defaultValue={
                                                                                        question.defaultValue &&
                                                                                        question.defaultValue
                                                                                    }
                                                                                    value={opt.value}
                                                                                    label={
                                                                                        <div style={RetainerLabelStyle}>
                                                                                            {textDisplay}
                                                                                            {showToolTip && (
                                                                                                <CustomTooltip
                                                                                                    title={opt?.title}
                                                                                                    description={getDiffRetainerLang(
                                                                                                        `subOptions.${opt.translationKey}`
                                                                                                    )}
                                                                                                    imgSrc={getWireOptImg(
                                                                                                        opt.value
                                                                                                    )}
                                                                                                    placement="right"
                                                                                                >
                                                                                                    <InfoIcon
                                                                                                        color={
                                                                                                            infoIconColor
                                                                                                        }
                                                                                                    />
                                                                                                </CustomTooltip>
                                                                                            )}
                                                                                        </div>
                                                                                    }
                                                                                />
                                                                            </>
                                                                        );
                                                                    })}
                                                                </>
                                                            }
                                                        />
                                                    </Grid>
                                                );
                                            }
                                        })}
                                </Grid>
                            </Grid>
                        </Grid>
                    );
                }
                return (
                    <Grid item xs={12}>
                        <RadioOptionRhf
                            disable={disabled}
                            value={v.value}
                            label={
                                <div style={RetainerLabelStyle}>
                                    {retainerTypeLabel}
                                    <RetainerTooltip label={retainerTypeLabel} value={v.value} placement="right">
                                        <InfoIcon color={infoIconColor} />
                                    </RetainerTooltip>
                                </div>
                            }
                        />
                    </Grid>
                );
            })}
        </>
    );
};

export default RetainerTypeFormControlLabelRhf;
